<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="title" description=""> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
</div>
